import React, { useState } from "react";
import CustomModal from "../../../CustomModal/CustomModal";
import { XCircleIcon } from "@heroicons/react/24/outline";

const AddTopic = ({ addTopic }) => {
  const [show, setShow] = useState(false);
  const [topicName, setTopicName] = useState("");

  const addTopicClick = (e) => {
    e.preventDefault();
    addTopic(topicName);
    setTopicName("");
    handleClose();
  };

  const handleClose = () => {
    setTopicName("");
    setShow(false);
  };
  const handleShow = () => setShow(true);
  return (
    <div>
      <button
        className="bg-white border border-purple1 px-4 py-2 text-purple1 text-sm font-inter font-medium rounded-md w-max hover:text-white hover:bg-purple1 transition-all ease-in-out duration-200 mt-3"
        onClick={handleShow}
      >
        Add Topic
      </button>
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        {show && (
          <>
            <div className="flex items-center justify-between border-b w-full py-4">
              <h4 className="text-base font-inter font-medium text-black pl-5">
                Add New Topic
              </h4>
              <XCircleIcon
                className="text-gray-400 h-6 w-6 mr-4 cursor-pointer"
                onClick={handleClose}
              />
            </div>
            <div className="w-full flex flex-col px-6 pt-5 pb-2">
              <div className="mb-3">
                <input
                  type="text"
                  placeholder="Enter topic name"
                  value={topicName}
                  onChange={(e) => setTopicName(e.target.value)}
                  className="px-4 py-2 outline-none border border-gray19 rounded-tl-md rounded-bl-md text-sm font-inter font-medium placeholder:text-gray20 text-gray18 w-full"
                />
              </div>
            </div>
            <div className="w-full flex items-center space-x-4 px-6 pb-5">
              <button
                className="bg-purple1 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
                onClick={addTopicClick}
              >
                Add New Topic
              </button>
              <button
                className="bg-white px-4 py-2 text-black/70 text-sm font-inter font-medium rounded-md border-gray22 border"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </>
        )}
      </CustomModal>
    </div>
  );
};

export default AddTopic;
